import React, { ReactNode } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogActions, DialogContent, DialogProps, Grow } from '@mui/material';
import { IconButton } from 'components/IconButton';
import MediaTypography from 'components/MediaTypography';

import { DialogHeader } from './style';

export interface IModalProps extends DialogProps {
	title?: string;
	image?: string;
	onClose: () => void;
	children?: ReactNode;
	actions?: ReactNode;
}

function Modal({ title, onClose, children, actions, open, image, ...props }: IModalProps) {
	return (
		<Dialog
			open={open}
			onClose={onClose}
			TransitionComponent={Grow}
			transitionDuration={500}
			{...props}
		>
			<DialogHeader withImage={!!image}>
				{title && (
					<MediaTypography variants={{ sm: 'h3' }} variant="h2">
						{title}
					</MediaTypography>
				)}
				{image && <img src={image} alt={image} />}
				<IconButton onClick={onClose} sx={{ background: '#FFFFFFB2' }}>
					<CloseIcon color="primary" />
				</IconButton>
			</DialogHeader>
			<DialogContent>{children}</DialogContent>
			{actions && <DialogActions>{actions}</DialogActions>}
		</Dialog>
	);
}

export default Modal;
